import clsx from 'clsx';

import styles from './page-header.module.scss';

export type PageHeaderProps = {
  title: string;
};

export function PageHeader({ title }: PageHeaderProps) {
  return <div className={clsx('page-header', styles['root'])}>{title}</div>;
}
